function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 9.1 15.5"
    },
    viewBox: "0 0 9.1 15.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.4 0 0 1.4l6.3 6.3L0 14.1l1.4 1.4 7.7-7.8z",
    style: {
      fill: "#4ea5b5"
    }
  }));
};
export default SvgArrowRight;